import { render, staticRenderFns } from "./SurrenderNoticePop.vue?vue&type=template&id=7a033612"
import script from "./SurrenderNoticePop.vue?vue&type=script&lang=js"
export * from "./SurrenderNoticePop.vue?vue&type=script&lang=js"
import style0 from "./SurrenderNoticePop.vue?vue&type=style&index=0&id=7a033612&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/AzDevOps/myagent/_work/11/s/frontend/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('7a033612')) {
      api.createRecord('7a033612', component.options)
    } else {
      api.reload('7a033612', component.options)
    }
    module.hot.accept("./SurrenderNoticePop.vue?vue&type=template&id=7a033612", function () {
      api.rerender('7a033612', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/pages/pdf/popup/SurrenderNoticePop.vue"
export default component.exports